import {get, post, uploadFile} from 'Utils/apiUtil';
import {callApi} from 'Utils/apiUtil';
import {
    f1OrderListUrl,
    getF1PackageOnTheGoListUrl,
    viewOrderTrackingUrl,
    getTaskListUrl,
    getAssignmentListUrl,
    getTaskCountUrl,
    getTaskDetailsDataUrl,
    getTaskAnswerDetailDataUrl,
    submitTaskUrl,
    uploadFileUrl,
    sysDictUrl,
    getOrderDetailMessageCountUrl,
    getOrderDetailOneKeyReadUrl,
    addMessageUrl,
} from 'Utils/urlUtil';
import util from 'Utils/commonUtil';

export const F1ORDERLIST = 'F1ORDERLIST'; //=
export const F1_PACKAGE_ON_THE_GO_ORDERLIST = 'F1_PACKAGE_ON_THE_GO_ORDERLIST'; //=
export const VIEW_ORDER_TRACKING = 'VIEW_ORDER_TRACKING'; //=

export const GET_TASK_LIST = 'GET_TASK_LIST';
export const GET_TASK_ASSIGNMENT_CUSTOMER_LIST =
    'GET_TASK_ASSIGNMENT_CUSTOMER_LIST';
export const GET_MORE_INITIAL_TASK_LIST = 'GET_MORE_INITIAL_TASK_LIST';
export const TASK_LIST_MORE_INITIAL = 'TASK_LIST_MORE_INITIAL';
export const TASK_LIST_MORE_FAILURE = 'TASK_LIST_MORE_FAILURE';
export const TASK_LIST_MORE_SUCCESS = 'TASK_LIST_MORE_SUCCESS';
export const TASK_COUNT = 'TASK_COUNT';
export const GET_TASK_DETAILS = 'GET_TASK_DETAILS';
export const TASK_LIST_SEARCH_FIELD = 'TASK_LIST_SEARCH_FIELD';
export const TASK_ASSIGNMENT_CUSTOMER_SEARCH_FIELD =
    'TASK_ASSIGNMENT_CUSTOMER_SEARCH_FIELD';
export const GET_CUSTOMER_QUESTION_DETAILS = 'GET_CUSTOMER_QUESTION_DETAILS';
export const SYS_DICT = 'SYS_DICT';
export const TASK_DETAIL_MESSAGE_COUNT = 'TASK_DETAIL_MESSAGE_COUNT';
export const TASK_DETAIL_ON_KEY_READ = 'TASK_DETAIL_ON_KEY_READ';
export const SET_FROM_HOST_REPLAY_PAGE = 'SET_FROM_HOST_REPLAY_PAGE';
export const SET_FROM_TASK_DETAIL_TO_MESSAGE_LIST_PAGE =
    'SET_FROM_TASK_DETAIL_TO_MESSAGE_LIST_PAGE';
export const UPDAT_TASK_MESSAGE_LIST_PAGE_NUM =
    'UPDAT_TASK_MESSAGE_LIST_PAGE_NUM';

const abyss = (data, length) => {
    let showAbyss = false;
    if (util.isArray(data) && data.length < length) {
        showAbyss = true;
    }
    return showAbyss;
};

export const getTaskList = (data) => (dispatch) =>
    dispatch(post(getTaskListUrl, data)).then((res) => {
        dispatch({type: GET_TASK_LIST, payload: res});
        return res;
    });

export const getTaskAssignmentCustomerList = (data) => (dispatch) =>
    dispatch(post(getAssignmentListUrl, data)).then((res) => {
        dispatch({type: GET_TASK_ASSIGNMENT_CUSTOMER_LIST, payload: res});
        return res;
    });

export const getTaskCount = () => (dispatch) => {
    dispatch({type: TASK_COUNT, payload: {}});
    return dispatch(get(getTaskCountUrl)).then((res) => {
        dispatch({type: TASK_COUNT, payload: res.data});
        return res;
    });
};

// Get task details
export const getTaskDetails = (params) => (dispatch) => {
    const url = `${getTaskDetailsDataUrl}?taskId=${params.taskId}&customerId=${params.customerId}`;
    dispatch({type: GET_TASK_DETAILS, payload: {}});
    return dispatch(get(url)).then((res) => {
        dispatch({type: GET_TASK_DETAILS, payload: res.data});
        return res;
    });
};

// Get task details
export const getTaskDetailsFromMessage = (params) => (dispatch) => {
    const url = `${getTaskAnswerDetailDataUrl}?taskLogId=${params.taskLogId}`;
    dispatch({type: GET_TASK_DETAILS, payload: {}});
    return dispatch(get(url)).then((res) => {
        dispatch({type: GET_TASK_DETAILS, payload: res.data});
        return res;
    });
};

// Update f1Order list Search Fields
export const updateTaskListSearchfields = (params) => ({
    type: TASK_LIST_SEARCH_FIELD,
    payload: params,
});

// Update f1Order list Search Fields
export const updateTaskAssignmentSearchfields = (params) => ({
    type: TASK_ASSIGNMENT_CUSTOMER_SEARCH_FIELD,
    payload: params,
});

// Get more product management list
export function getMoreTaskAssignmentCustomerList(params) {
    return (dispatch, getState) => {
        const taskManagement = getState().taskManagement;

        const options = {
            data: params,
        };
        const request = () => ({
            type: TASK_LIST_MORE_INITIAL,
            payload: {
                assignmentCustomerListLoaded: false,
                assignmentCustomerLoadingMore: true,
                assignmentCustomerAbyss: false,
            },
        });
        const failure = () => ({
            type: TASK_LIST_MORE_FAILURE,
            payload: {
                assignmentCustomerListLoaded: true,
                assignmentCustomerLoadingMore: false,
                assignmentCustomerAbyss: true,
            },
        });
        const success = (response) => {
            const apiReponseData = response.data;
            const list = util.isArray(response.data)
                ? taskManagement.assignmentCustomerList.data.concat(
                      response.data,
                  )
                : [];
            response.data = list;

            return {
                type: TASK_LIST_MORE_SUCCESS,
                payload: {
                    assignmentCustomerList: response,
                    assignmentCustomerListLoaded: true,
                    assignmentCustomerLoadingMore: false,
                    assignmentCustomerAbyss: abyss(
                        apiReponseData,
                        taskManagement.assignmentCustomerList.pageSize,
                    ),
                },
            };
        };

        return dispatch(
            callApi(getAssignmentListUrl, options, request, success, failure),
        );
    };
}

export const submitTask = (params) => post(submitTaskUrl, params);

export const addMessage = (params) => post(addMessageUrl, params);

// Update F1 Order Search Fields
export const setFromHostReplayPage = (params) => ({
    type: SET_FROM_HOST_REPLAY_PAGE,
    payload: params,
});

export const getCustomerDetails = (params) => (dispatch) => {
    const url = `${getTaskDetailsDataUrl}?taskId=${params.taskId}&customerId=${params.customerId}`;
    dispatch({type: GET_CUSTOMER_QUESTION_DETAILS, payload: {}});
    return dispatch(get(url)).then((res) => {
        dispatch({type: GET_CUSTOMER_QUESTION_DETAILS, payload: res.data});
        return res;
    });
};

export const uploadReceiveImage = (data) => uploadFile(uploadFileUrl, data);

export function getSysDict(dictType) {
    return (dispatch) =>
        dispatch(get(sysDictUrl, {dictType})).then((res) => {
            dispatch({type: SYS_DICT, payload: res});
        });
}

export const getTaskDetailMessageCount = (data) => (dispatch) =>
    dispatch(post(getOrderDetailMessageCountUrl, data)).then((res) => {
        dispatch({type: TASK_DETAIL_MESSAGE_COUNT, payload: res});
        return res;
    });

export const getTaskDetailOneKeyRead = (data) => (dispatch) =>
    dispatch(post(getOrderDetailOneKeyReadUrl, data)).then((res) => {
        dispatch({type: TASK_DETAIL_ON_KEY_READ, payload: res});
        return res;
    });

// Get F1 orders
export const getF1OrderList = (data) => (dispatch) =>
    dispatch(post(f1OrderListUrl, data)).then((res) => {
        dispatch({type: F1ORDERLIST, payload: res});
        return res;
    });

// Get F1 orders
export const getF1PackageOnTheGoList = (data) => (dispatch) =>
    dispatch(post(getF1PackageOnTheGoListUrl, data)).then((res) => {
        dispatch({type: F1_PACKAGE_ON_THE_GO_ORDERLIST, payload: res});
        return res;
    });

// Get F1 orders
export const viewOrderTracking = (data) => (dispatch) =>
    dispatch(post(viewOrderTrackingUrl, data)).then((res) => {
        dispatch({type: VIEW_ORDER_TRACKING, payload: res});
        return res;
    });

// Update F1 Order Search Fields
export const setFromTaskDetailToMessageListPage = (params) => ({
    type: SET_FROM_TASK_DETAIL_TO_MESSAGE_LIST_PAGE,
    payload: params,
});

// Update F1 Order Search Fields
export const updateTaskMessageListPageNum = (params) => ({
    type: UPDAT_TASK_MESSAGE_LIST_PAGE_NUM,
    payload: params,
});
